import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  /** When set, renders a back-link above the title. */
  backTo?: string;
  backLabel?: string;
  /** Right-aligned actions slot (buttons, badges, etc.). */
  actions?: ReactNode;
}

/** Standard page header: optional back-link, h1 + muted description, actions. */
export function PageHeader({
  title,
  description,
  backTo,
  backLabel = 'Back',
  actions,
}: PageHeaderProps): JSX.Element {
  return (
    <div className="space-y-1">
      {backTo && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          {backLabel}
        </Link>
      )}
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">{title}</h1>
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-3">{actions}</div>}
      </div>
    </div>
  );
}
